// extracted by mini-css-extract-plugin
export default {"card":"Card_card__uFbbj","cardinfo":"Card_cardinfo__uZSK0","title":"Card_title__0JK0c","image":"Card_image__ML5s1","NavLink":"Card_NavLink__U2UlO"};